import React from 'react'

const Manual_metodo_pago_yappy = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Método de pago Yappy
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Habilita y configura el método de pago Yappy dentro del portal de Ecommerce de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Metodo_de_pago_Yappy__pEqUxwryShS4VePm5CMm1w?as=scrollable"
          className="scribe-iframe-general-106"
          width="100%"
          height="5700"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_metodo_pago_yappy
